import { render } from "./agent.clients.preview.vue?vue&type=template&id=6a9c588a"
import script from "./agent.clients.preview.vue?vue&type=script&lang=js"
export * from "./agent.clients.preview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__